module.exports = __webpack_public_path__ + "fonts/Gotham-Light.0ff4bccb.otf";